/**
 * Fetch Shoutcast stats XML from the browser when the server-side tRPC proxy fails
 * (e.g. cast4 blocks Vercel egress). Tries several public CORS proxies in order.
 */
export async function fetchStatsXmlViaCorsProxy(
  statsUrl: string,
  signal?: AbortSignal
): Promise<string | null> {
  // Codetabs requires `/proxy/?quest=` (with slash before `?`); otherwise it 301s to HTML and XML parse fails.
  // Order: fast working proxy first; allorigins can be slow on cold start.
  const proxies: string[] = [
    `https://api.codetabs.com/v1/proxy/?quest=${encodeURIComponent(statsUrl)}`,
    `https://api.allorigins.win/raw?url=${encodeURIComponent(statsUrl)}`,
    `https://corsproxy.io/?${encodeURIComponent(statsUrl)}`,
  ];

  for (const proxyUrl of proxies) {
    try {
      const res = await fetch(proxyUrl, {
        signal,
        cache: "no-store",
        headers: { Accept: "text/xml,application/xml,text/plain,*/*" },
      });
      if (!res.ok) continue;
      const text = await res.text();
      if (/<SONGTITLE/i.test(text)) return text;
    } catch {
      continue;
    }
  }
  return null;
}
